import dashboard from './dashboard'
import contents from './contents'
import counselings from './counselings'
import services from './services'
import settings from './settings'
import persons from './persons'
import usersAndRoles from './users-and-roles'
import pages from './pages'
import questions from './questions'

// Array of sections
export default [...dashboard, ...usersAndRoles, ...services, ...contents, ...pages, ...questions, ...settings, ...persons, ...counselings]
